export default __webpack_public_path__ + "static/ashwin-goyal-7a38631c513142024074c51158024b9a.png";